import { render } from "./CustomCategoriser.vue?vue&type=template&id=4987680d"
import script from "./CustomCategoriser.vue?vue&type=script&lang=js"
export * from "./CustomCategoriser.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__